import axios from "axios";
import http from "@/api/http.js";

export function listImageBatches() {
  return http.get("image_batches");
}

export function getImageBatch(batchId) {
  return http.get(`image_batches/show/${batchId}`);
}

export function requestImageBatchUpload(filename) {
  return http.post("image_batches/request_upload", { filename });
}

// uploads the zip file directly to S3 using the presigned url, bypassing the API server
export function uploadZipToS3(uploadUrl, file, onUploadProgress) {
  return axios.put(uploadUrl, file, {
    headers: { "Content-Type": "application/zip" },
    onUploadProgress
  });
}

export function extractImageBatch(batchId) {
  return http.post(`image_batches/extract/${batchId}`);
}

export function processNextImageBatchChunk(batchId, limit = 3) {
  return http.post(`image_batches/process_next/${batchId}`, { limit });
}
